import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  section: {
    width: '100%',
    paddingTop: theme.spacing(1.5),
    marginBottom: theme.spacing(-2),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    minHeight: theme.spacing(16),
    boxSizing: 'border-box',
    maxHeight: theme.spacing(42.875),
    overflow: 'auto',
    paddingRight: theme.spacing(2),
    '&::-webkit-scrollbar-track': {
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar-thumb': {
      width: theme.spacing(1),
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgSecondary.main,
    },
  },
  stakeholderTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    color: theme.palette.labraText.tertiary,
  },
  stakeholderTitleWrapper: {
    display: 'flex',
    width: '95%',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  stakeholderTitleName: {
    fontSize: '16px',
    lineHeight: theme.spacing(3),
    color: theme.palette.labraText.secondaryDescription,
  },
  rowItem: {
    padding: theme.spacing(1.5, 0),
  },
  rightSection: {
    padding: `${theme.spacing(2, 3)}`,
  },
  editActionLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  disabledEdit: {
    opacity: '39%',
  },
  lastRowItem: {
    paddingBottom: `${theme.spacing(2)} !important`,
  },
  stakeholderName: {
    color: theme.palette.labraText.tertiary,
  },
  emptySection: {
    paddingBottom: theme.spacing(2.5),
  },
}))
